/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate Web Admin
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.4-12-g918a4012-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const LdapUsernameAttribute = {
    Cn: 'Cn',
    Uid: 'Uid',
    Email: 'Email',
    UserPrincipalName: 'UserPrincipalName',
    SamAccountName: 'SamAccountName'
};
export function instanceOfLdapUsernameAttribute(value) {
    for (const key in LdapUsernameAttribute) {
        if (Object.prototype.hasOwnProperty.call(LdapUsernameAttribute, key)) {
            if (LdapUsernameAttribute[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function LdapUsernameAttributeFromJSON(json) {
    return LdapUsernameAttributeFromJSONTyped(json, false);
}
export function LdapUsernameAttributeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function LdapUsernameAttributeToJSON(value) {
    return value;
}
